import { useId } from 'react';
import { levelText } from '../utils/serviceLevels';
import './ServiceLevelToggle.css';

/** Scenario 5's service level, one button per level, the one shown pressed. */
export default function ServiceLevelToggle({ levels, value, onChange, className = '' }) {
  const labelId = useId();
  return (
    <div className={`sl-toggle ${className}`}>
      <span className="sl-toggle-label" id={labelId}>Service level</span>
      <div className="sl-toggle-group" role="group" aria-labelledby={labelId}>
        {levels.map((level) => (
          <button key={level} type="button" aria-pressed={level === value} onClick={() => onChange(level)}>
            {levelText(level)}
          </button>
        ))}
      </div>
    </div>
  );
}
